(ns frontend.view.modals.value-creation.events
  (:require
   [frontend.logging :as logging]
   [frontend.actions.entity :as entity-actions]
   [basic-components.attachments :as attachments-view]
   [frontend.actions.attachment :as attachment-actions]
   [frontend.actions.common :as common-actions]
   [common.localization :as loc]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.notification.view :as notification-modal]))

(defn create-value-creation!
  [{:keys [state parent-entity-id related-entities close-modal!]}]
  (entity-actions/*->create
   {:entity/type :entity.type/value-creation
    :value-creation/parent-entity parent-entity-id
    :common/related-entities (set (concat related-entities [parent-entity-id]))
    :value-creation/status :value-creation.status/not-started}
   (fn [{:keys [body]}]
     (let [entity body
           created-entity-id (:db/id entity)]
       (swap! state dissoc :processing?)
       (swap! state assoc :value-creation-id created-entity-id)
       (logging/info "Created value creation " created-entity-id)))
   (fn [err]
     (swap! state dissoc :processing?)
     (close-modal!)
     (modals/open-modal!
      notification-modal/modal-key
      {:body-text      (loc/tr :something-went-wrong)
       :title          (loc/tr :attention)
       :ok-button-text (loc/tr :ok)})
     (logging/error "Failed to create value creation " err))))

(defn cancel-value-creation!
  [value-creation-id state]
  (entity-actions/*->disable!
   value-creation-id
   (fn [resp]
     (swap! state dissoc :value-creation-id)
     (logging/info "Successfully deleted value creation " resp))
   (fn [err]
     (logging/error "Failed to delete value creation " err))))

(defn save-changes!
  [{:keys [state value-creation-id close-modal! updates-atom]}]
  (entity-actions/*->entity-update!
   value-creation-id
   @updates-atom
   (fn [resp]
     (swap! state dissoc :value-creation-id :processing?)
     (logging/info "Successfully updates value creation " resp)
     (close-modal!))
   (fn [err]
     (logging/error "Failed to update value creation " err))))

(defn add-attachment-to-entity!
  [{:keys [state db/id on-success! on-error!]} {:keys [files original-event]}]
  (when (aget files 0)
    (let [file (aget files 0)
          name (.-name file)
          size (.-size file)
          attachment {:filename    name
                      :description nil
                      :file        file
                      :target      id}
          token-success!
          (fn [token]
            (attachments-view/add-indicator! state token name size)
            (attachment-actions/*=>add-attachment
             {:multipart-params (assoc attachment :token token)}
             (fn [resp]
               (attachments-view/remove-indicator! state token)
               (on-success! (:body resp)))
             (fn [resp]
               (on-error! (:body resp))
               (attachments-view/show-indicator-error! state
                                                       token
                                                       (loc/tr :attachment-indicator-error)))))]
      (common-actions/*<-create-op-token nil
                                         token-success!
                                         (fn [e]
                                           (logging/error "resp token=" e))))))

(defn close-modal!
  [{:keys [entity-id close-modal! value-creation-id state entity-atom]}]
  (if entity-id
    (close-modal!)
    (do (cancel-value-creation! value-creation-id state)
        (close-modal!))))

(def holding-fields
  [{:attribute-key :value-creation/title}
   {:attribute-key :value-creation/holding-category}
   {:attribute-key :value-creation/holding-subcategory}
   {:attribute-key :value-creation/description-and-lessons-learned}
   ;   {:attribute-key :value-creation/international-aspect}
   {:attribute-key :value-creation/cross-category-theme}
   {:attribute-key :value-creation/our-manager}
   {:attribute-key :value-creation/execution-year}
   {:attribute-key :value-creation/our-role}
   {:attribute-key :value-creation/holding-our-managers-role}
   {:attribute-key :value-creation/status}
   {:attribute-key :value-creation/results}
   {:attribute-key :value-creation/help-needed}
   {:attribute-key :value-creation/help-needed-description}])

(def ordered-holding-fields
  (->> holding-fields
       (map-indexed (fn [idx field]
                      (assoc field :ord idx)))))

(def investor-fields
  [{:attribute-key :value-creation/title}
   {:attribute-key :value-creation/description-and-lessons-learned}
   {:attribute-key :value-creation/our-managers}
   {:attribute-key :value-creation/date-execution-date}
   {:attribute-key :value-creation/target}
   {:attribute-key :value-creation/investor-maturity}
   {:attribute-key :value-creation/agm-and-advisory-boards}
   {:attribute-key :value-creation/investor-categories}
   {:attribute-key :value-creation/investor-subcategories}
   {:attribute-key :value-creation/our-role}
   {:attribute-key :value-creation/investor-our-managers-role}
   {:attribute-key :value-creation/opt-17592200887814-esg-development-plan-topic}
   ;   {:attribute-key :value-creation/international-aspect}
   {:attribute-key :value-creation/cross-category-theme}
   {:attribute-key :value-creation/status}])

(def ordered-investor-fields
  (->> investor-fields
       (map-indexed (fn [idx field]
                      (assoc field :ord idx)))))

(def holding-mandatory-fields
  [:value-creation/holding-category
   :value-creation/holding-subcategory
   :value-creation/help-needed
   :value-creation/execution-year
   :value-creation/holding-our-managers-role
   :value-creation/our-manager])

(def investor-mandatory-fields
  [:value-creation/investor-maturity
   :value-creation/investor-categories
   :value-creation/target
   :value-creation/date-execution-date
   :value-creation/investor-our-managers-role
   :value-creation/our-managers])

(def common-mandatory-fields
  [:value-creation/title
   :value-creation/description-and-lessons-learned
   ;:value-creation/international-aspect
   :value-creation/cross-category-theme
   :value-creation/our-role
   :value-creation/status])

(defn mandatory-fields
  [containing-entity-type]
  (concat common-mandatory-fields
          (when (= containing-entity-type :entity.type/investor)
            investor-mandatory-fields)
          (when (= containing-entity-type :entity.type/holding)
            holding-mandatory-fields)))

(defn go-to-the-next-step!
  [state]
  (let [modal-step (:modal-step @state)]
    (cond (= :editor-view modal-step)
          (swap! state assoc :modal-step :associations-view)
          (= :associations-view modal-step)
          (swap! state assoc :modal-step :attachments-view)
          :else
          nil)))

(defn go-back!
  [state]
  (let [modal-step (:modal-step @state)]
    (cond (= :associations-view modal-step)
          (swap! state assoc :modal-step :editor-view)
          (= :attachments-view modal-step)
          (swap! state assoc :modal-step :associations-view)
          :else
          nil)))

(defn get-value
  [entity-atom updates-atom attribute]
  (let [current-value (get @entity-atom attribute)
        edits @updates-atom
        value (if (contains? edits attribute)
                (get edits attribute)
                current-value)]
    value))

